"use strict";
import React, { Component, ReactNode } from "react";
import { View } from "react-native";

export default () => {
  return <View></View>;
};
